<div class="overlay" (click)="onCloseOverlay()"></div>